import { Text, TextProps } from '../../Text';

function Label({ as = 'label', variant = 'body-1', color = 'default', weight = 'medium', ...props }: TextProps<'label'>) {
  return <Text.Abstract as={as as 'label'} variant={variant} color={color} weight={weight} {...(props as TextProps<'label'>)} />;
}

export { Label };
